import { LoginUsersService } from "./../../Services/login-users.service";
import { LoyaltyService } from "./../../Services/loyalty.service";
import {
    Component,
    AfterViewInit,
    HostListener,
    Input,
    OnInit,
    ViewChild,
    OnDestroy,
    OnChanges,
    ChangeDetectorRef,
    SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EmbryoService } from "../../Services/Embryo.service";
import { Location } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { SizeChartsDialogComponent } from "./size-charts-dialog/size-charts-dialog.component";
import { DomSanitizer, SafeUrl, Title, Meta } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { ReactivityService } from "../../Services/reactivity.service";
import { AccountSettingService } from "src/app/Services/account-setting.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { ShareDialogComponent } from "../share-dialog/share-dialog.component";
import { MetaService } from "src/app/Services/meta-data.service";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment.prod";

@Component({
    selector: "embryo-ShopDetails",
    templateUrl: "./ShopDetails.component.html",
    styleUrls: ["./ShopDetails.component.scss"],
})
export class ShopDetailsComponent
    implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
    @ViewChild("zoomViewer", { static: false }) zoomViewer: any;

    @Input() lang: string = "en";
    @Input() detailData: any;
    @Input() currency: string = "";
    mainImgPath: string = "";
    totalPrice: any;
    type: any;
    productReviews: any;
    productOptionsSelect = [];
    product_variant: any;
    productList: any;
    valueQuantity = 1;
    zoomImage: string = "";
    size_id: string = "";
    available_options_color: any[] = [];
    available_value_color: any[] = [];
    available_options_size: any[] = [];
    available_value_size: any[] = [];
    size_error: boolean = false;
    activeTab: string = 'tab1';
    selectedValues: any[] = [];
    availableValues: any[] = [];
    variantId: any;
    showDetailBar: any;
    youtubeTrustedThumbnailUrl: SafeUrl = "";
    videoUrl: string = "";
    first_time = true;
    user: any;
    wishListProducts: Array<any>;
    compareListProducts: Array<any>;
    subscription: Subscription;
    toggleLoading: boolean = false;
    toggleCompareLoading: boolean = false;
    toggleCartLoading: boolean = false;
    toggleFavLoading: boolean = false;
    isAuthUser: any;
    environmentVariables: any;
    breadCrumbsRoutes: Array<any> = [];
    option2Selected: any;
    selected_color: any;
    areaSubscription: Subscription;
    branchSubscription: Subscription;
    cartStatusCode: any;
    _slug: any;
    copyedDetailData: any;
    htmlDiscreptionValue: any;
    youtubeTrustedUrl: SafeUrl = ""; // for product details youtube url only
    @Input() installment: any = null;
    selectedBank: any = null;
    selectedInstallmentPlans: any[] = [];
    selectedPlan: any = null;
    firstTimeOnChange = true
    isMobilaty: boolean = environment.api.includes('mobilaty'); 

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public embryoService: EmbryoService,
        private _location: Location,
        public translate: TranslateService,
        private sanitizer: DomSanitizer,
        public dialog: MatDialog,
        private title: Title,
        private reactivityService: ReactivityService,
        public snackBar: MatSnackBar,
        public loyaltyService: LoyaltyService,
        public userLoginServies: LoginUsersService,
        private account: AccountSettingService,
        private confgServ: StaticPagesService,
        private marketingService: MarketingService,
        private metaService: MetaService,
        private cdref: ChangeDetectorRef,

    ) {


        this.getInitilizingData();
        this.areaSubscription = this.userLoginServies
            .getAreaDataEmit()
            .subscribe((res) => {
                this.getVariantSelected();
            });
        this.branchSubscription = this.userLoginServies
            .getBranchDataEmit()
            .subscribe((res) => {
                this.getVariantSelected();
            });
        this.wishListProducts = [];
        this.compareListProducts = [];
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                if (data && data.currentFavProduct) {
                }
            }
        );
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }
    openDialogShare() {
        const dialogRef = this.dialog.open(ShareDialogComponent, {
            data: this.detailData,
            panelClass: "product-dialog",
            height: "80vh",
        });
    }
    mailMe() {
        let mailText = "mailto:?subject=files&body=" + window.location.href;
        window.location.href = mailText;
    }

    ngOnInit() {
        this.createBreadCrumbsRoutes();
        setTimeout(() => {
            if (this.lang == "en") {
                this.title.setTitle(
                    this.detailData.meta_title
                        ? `${this.detailData.meta_title} | ${this.environmentVariables?.META_TITLE_EN}`
                        : `${this.detailData?.name_en} | ${
                              this.environmentVariables?.META_TITLE_EN
                                  ? this.environmentVariables?.META_TITLE_EN
                                  : this.environmentVariables?.WEBSITE_URL
                          } `
                );
                this.metaService.updateTag({
                    property: "og:title",
                    content: this.detailData?.meta_title,
                });
            } else {
                this.title.setTitle(
                    this.detailData.meta_title
                        ? `${this.detailData.meta_title} | ${this.environmentVariables?.META_TITLE_AR}`
                        : `${this.detailData?.name_ar} | ${
                              this.environmentVariables?.META_TITLE_AR
                                  ? this.environmentVariables?.META_TITLE_AR
                                  : this.environmentVariables?.WEBSITE_URL
                          } `
                );
                this.metaService.updateTag({
                    property: "og:title",
                    content: this.detailData?.meta_title_ar,
                });
            }
            
            if(this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID){
                this.marketingService.GA4SelectContentEvent({
                    content_type: "product",
                    item_id: this.detailData.id,
                    item_name:this.detailData.name
                });
            }
        }, 1000);
        this.getVariantSelected();
        this.toggleFavLoading = false;
        this.user = this.userLoginServies.getUser();
        this.metaService.updateTag({
            property: "keywords",
            content:
                this.lang == "en"
                    ? this.detailData.product_variants.keywords
                    : this.detailData.product_variants.keywords_ar,
        });
        document
            .getElementById("ProductModelNo")
            ?.setAttribute("content", this.detailData.product_variants[0].sku);

        if (this.detailData.name_en && this.lang == "en") {
            this.metaService.updateTag({
                property: "og:description",
                content: this.detailData.meta_description,
            });
            document
                .getElementById("MetaDescription")
                ?.setAttribute(
                    "content",
                    this.detailData.meta_description
                        ? `${this.detailData.meta_description}`
                        : `${this.detailData.name_en} | ${
                              this.environmentVariables?.metaDescriptionEn
                                  ? this.environmentVariables?.metaDescriptionEn
                                  : `Shop for it at ${this.environmentVariables?.WEBSITE_URL}.Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy it online from ${this.environmentVariables?.WEBSITE_URL}`
                          }`
                );
        }
        if (this.detailData.name_ar && this.lang == "ar") {
            this.metaService.updateTag({
                property: "og:description",
                content: this.detailData.meta_description_ar,
            });
            document
                .getElementById("MetaDescription")
                ?.setAttribute(
                    "content",
                    this.detailData.meta_description
                        ? `${this.detailData.meta_description}`
                        : `${this.detailData.name_ar} | ${
                              this.environmentVariables?.metaDescriptionAr
                                  ? this.environmentVariables?.metaDescriptionAr
                                  : `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.WEBSITE_URL}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.WEBSITE_URL}`
                          }`
                );
        }
    }

    transform(value: any) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }

    ngOnChanges(changes: SimpleChanges) {
        if(!this.firstTimeOnChange){
            if (changes?.detailData?.currentValue) {
                this.detailData = changes?.detailData?.currentValue;
                this.resolveVariant();
            }
            // if (changes?.lang) {
            //     this.lang = changes?.lang?.currentValue;
            //     this.resolveVariant();
            //  }
        }
        this.firstTimeOnChange = false
        this.setOptionValuesStates();
        if (this.detailData.product_variants) {
            document
                .getElementById("keywordsMeta")
                ?.setAttribute(
                    "content",
                    this.lang == "en"
                        ? this.detailData.product_variants[0].keywords
                        : this.detailData.product_variants[0].keywords_ar
                );
        }
        if(this.installment){
            this.selectedBank = this.installment.instalment_banks[0];
            this.selectedInstallmentPlans = this.selectedBank.plans;
            this.selectedPlan = this.selectedInstallmentPlans[0];
        }
    }

    getVariantSelected() {
        this.route.queryParams.subscribe((params) => {
            if (this.detailData && this.detailData?.product_variants?.length) {
                let x = Number(params["variant"]);
                this.variantId = this.router.url.split("/").pop();
                this._slug = this.router.url.split("/").pop();
            }

            if (this.first_time) this.first_time = false;

            this.SetData();
        });
    }

    ngAfterViewInit() {
        let profile = JSON.parse(localStorage.getItem('auth_user_crocs')!);
        let vistorId = localStorage.getItem('vistorId');
        let item = this.detailData?.id
        this.marketingService.initCriteoq(profile, vistorId, 'viewItem' , item);
  
        setTimeout(() => {
            this.embryoService.productCartSub.subscribe(
                (res) => (this.productList = res)
            );
            this.embryoService.favouritesListSub.subscribe((res) => {
                this.wishListProducts = res;
                this.setVariantsFavorite();
            });
            this.embryoService.compareListSub.subscribe((res) => {
                this.compareListProducts = res;
                this.setVariantsCompare();
            });
        }, 10);

        if (!this.detailData.long_description &&
            !this.product_variant.youtube_trusted_url &&
            !this.product_variant.details_banners?.length &&
            !this.product_variant.details_cards?.length &&
            !this.product_variant.custom_specs?.length
        ) {
            this.showTabContent("tab2");
        }
        
        if (this.environmentVariables.PRODUCT_TYPE == "variant") {
            this.copyedDetailData = this.detailData?.product_variants.find(
                (a: any) => a.slug == this._slug
            );
            this.copyedDetailData.description
                ? this.removeHTMLTags(this.copyedDetailData.description)
                : "";
        }

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = `
                {
                    "@context": "https://schema.org",
                    "@type": "Product",
                    "name": "${this.handleQoutesInName(
                        this.copyedDetailData?.name
                            ? this.copyedDetailData?.name
                            : "product name"
                    )}",
                    "description": "${this.handleQoutesInName(
                        this.copyedDetailData.description
                            ? this.removeHTMLTags(
                                  this.copyedDetailData.description
                              )
                            : ""
                    )}",
                    "image": "${this.copyedDetailData?.image}",
                    "offers": [
                        {
                            "@type": "Offer",
                            "priceCurrency": "${
                                this.environmentVariables.CURRENCY_CODE_EN
                            }",
                            "price": ${
                                this.copyedDetailData.discount_price
                                    ? this.copyedDetailData.discount_price
                                    : this.copyedDetailData?.price
                            },
                            "seller": {
                                "@type": "Organization",
                                "name": "${this.environmentVariables.APP_NAME}"
                            },
                            "url": "${this.copyedDetailData?.share_link}",
                            "sku": "${this.copyedDetailData?.sku}",
                            "mpn": "${this.copyedDetailData?.sku}"
                        }
                    ],
                    "url": "${this.copyedDetailData?.share_link}",
                    "manufacturer": {
                        "@type": "Organization",
                        "name": "${this.handleQoutesInName(
                            this.copyedDetailData?.details?.brand?.name
                        )}"
                    },
                    "sku": "${this.copyedDetailData?.sku}",
                    "mpn": "${this.copyedDetailData?.sku}"
                }
            `;
        document.body.appendChild(script);
    }

    handleQoutesInName(str: any) {
        return str?.replace(/"/g, '\\"');
    }

    removeHTMLTags(code: any) {
        // Regular expression to match HTML tags
        const regex = /<[^>]+>/g;

        // Remove HTML tags using replace()
        const cleanCode = code?.replace(regex, "");
        return cleanCode;
    }

    ngOnDestroy() {
        this.areaSubscription.unsubscribe();
        this.branchSubscription.unsubscribe();
        if (this.subscription) this.subscription.unsubscribe();
        this.lang === "en"
            ? this.title.setTitle(
                  `${
                      this.environmentVariables?.sloganEn ||
                      this.environmentVariables?.APP_NAME
                  }`
              )
            : this.title.setTitle(
                  `${
                      this.environmentVariables?.sloganAr ||
                      this.environmentVariables?.APP_NAME_AR
                  }`
              );
    }

    SetData() {
        this.detailData?.product_variants?.forEach((pv: any) =>
            pv.images.unshift({ url: pv.image })
        );

        if (this.userLoginServies.isGuest()) {
            this.setVariantsFavorite();
        }
        if (
            this.detailData &&
            this.detailData?.product_variants_options[1]?.option
                ?.preview_type == 2
        ) {
            this.option2Selected =
                this.detailData?.product_variants_options[1]?.values[0]?.id;
        }
        if (this.detailData && this.detailData?.product_variants?.length) {
            this.resolveVariant();
            this.selectedValues = [];
            const firstVariant = this.product_variant;
            firstVariant.options?.forEach((option: any) => {
                if (option.values.length) {
                    const value = option.values[0];
                    value.option_id = option.option.id;
                    this.selectedValues.push(value);
                }
            });

            this.availableValues = this.getAvailableValues();
            this.setOptionValuesStates();
            this.setMainData();
        } else {
            this.detailData.in_stock = false;
            this.mainImgPath = this.detailData?.image;
        }

        window.scrollTo(0, 0);
        this.detailData?.product_variants?.forEach(
            (element: any) => (element.first_time = true)
        );
        if (this.productList && this.productList.length) {
            this.available_value_color = [];
            this.detailData?.product_variants?.forEach((element: any) => {
                element.options?.forEach((option: any) => {
                    if (
                        option.option.type == "4" ||
                        option.option.type == "2"
                    ) {
                        this.available_options_color.push(option.option);
                        option.values?.forEach((value: any) => {
                            this.available_value_color.push(value);
                        });
                    } else if (option.option.type == "1") {
                        this.available_options_size.push(option.option);
                        option.values?.forEach((value: any) =>
                            this.available_value_size.push(value)
                        );
                    }
                });

                const index = this.productList.findIndex(
                    (item: any) => item.id == element.id
                );

                if (index !== -1)
                    element.quantity = this.productList[index].quantity;
            });
        }
        if (
            this.detailData &&
            this.detailData?.product_variants &&
            this.detailData?.product_variants?.length
        ) {
            this.detailData?.product_variants?.forEach((element: any) => {
                if (
                    (this.userLoginServies.isGuest() &&
                        localStorage.getItem("compareItems")) ||
                    ""
                ) {
                    const index = JSON.parse(
                        <string>localStorage.getItem("compareItems") || ""
                    ).findIndex((item: any) => item.id == this.variantId);
                    element.is_compare = index !== -1;
                } else {
                    if (
                        this.compareListProducts &&
                        this.compareListProducts.length
                    ) {
                        const index = this.compareListProducts.findIndex(
                            (item) => item.id == this.variantId
                        );
                        element.is_compare = index !== -1;
                    }
                }

                element.options?.forEach((option: any) => {
                    if (
                        option.option.type == "4" ||
                        option.option.type == "2"
                    ) {
                        this.available_options_color.push(option.option);
                        option.values?.forEach((value: any) =>
                            this.available_value_color.push(value)
                        );
                    } else if (option.option.type == "1") {
                        this.available_options_size.push(option.option);
                        option.values?.forEach((value: any) =>
                            this.available_value_size.push(value)
                        );
                    }
                });

                /*  youtube details link */
                if(element?.youtube_url){
                    const youtubeEmbedId = element.youtube_url.split("v=")[1];
                    const youtubeEmbedUrl = `https://www.youtube.com/embed/${youtubeEmbedId}`;
                    element.youtube_trusted_url =
                        this.sanitizer.bypassSecurityTrustResourceUrl(youtubeEmbedUrl);
                }

                /* split details custom_specs list in two tables */
                if(element?.custom_specs?.length > 0){
                    const small_specs_list_length = Math.ceil(
                        element.custom_specs.length / 2
                    );
                    element.custom_specs1 = element.custom_specs.slice(
                        0,
                        small_specs_list_length
                    );
                    if(element.custom_specs.length > 1){
                        element.custom_specs2 = element.custom_specs.slice(
                            small_specs_list_length,
                            element.custom_specs.length
                        );
                    }
                }
            });
            this.available_value_color = this.available_value_color.filter(
                (color, index, color2) =>
                    index === color2.findIndex((t: any) => t.id === color.id)
            );
            this.available_value_size = this.available_value_size.filter(
                (color, index, color2) =>
                    index === color2.findIndex((t: any) => t.id === color.id)
            );
        }

        this.getYouTubeUrlThumbnail();
    }

    @HostListener("window:scroll", ["$event"])
    onScrollEvent($event: any) {
        const buttonCartTop = document
            .getElementById("btnAddToCart")
            ?.getBoundingClientRect().top;
        buttonCartTop && buttonCartTop < 120
            ? (this.showDetailBar = true)
            : (this.showDetailBar = false);
    }

    resolveVariant() {
        console.log('this.variantId ===>', this.variantId)
        if (this.variantId) {
            const ind = this.detailData?.product_variants?.findIndex(
                (v: any) => v.slug === this.variantId
            );
            ind !== -1
                ? (this.product_variant =
                      this.detailData?.product_variants[ind])
                : (this.product_variant = this.detailData?.product_variants[0]);
         } else {
            this.product_variant = this.detailData?.product_variants[0];
            this._location.go(
                `/${this.lang}/${this.detailData?.product_variants[0].slug}`
            );
        }
        this.setProductData()
        this.marketingService.productClickEvent(
            "productClick",
            this.product_variant
        );
        let resultViewItem = <any>{
            content_ids: this.product_variant?.id,
            content_category: this.detailData?.category?.name,
            content_name: this.product_variant?.name,
            content_type: "product",
            contents: [{ id: this.product_variant?.id, quantity: 1 }],
            currency: this.environmentVariables?.CURRENCY_CODE_EN,
            value: this.product_variant?.discount_price
                ? this.product_variant?.discount_price
                : this.product_variant?.price,
        };
        this.marketingService.fbTracking(
            "track",
            "ViewContent",
            resultViewItem
        );

        if(this.environmentVariables?.tiktokPixelId){
            this.marketingService.ttqTracking('track', 'ViewContent',{
                resultViewItem 
            })
        }

        this.marketingService.snapTracking(
            "track",
            "VIEW_CONTENT",
            {
                 item_ids:  this.product_variant?.id,
                price:this.product_variant?.discount_price
                       ? this.product_variant?.discount_price
                       : this.product_variant?.price,
                 currency: this.environmentVariables?.CURRENCY_CODE_EN,
            }
        );

        if (this.environmentVariables?.GOOGLE_CONVERSION_ID) {
            this.marketingService.googleConversionTracking(
                "conversion",
                this.environmentVariables?.GOOGLE_CONVERSION_ID,
                this.environmentVariables?.GOOGLE_CONVERSION_LABEL_PRODUCT_DETAILS_PAGE,
                this.environmentVariables?.GOOGLE_CONVERSION_TRANSACTION_ID
            );
        }
        this.detailData.meta_title = this.product_variant?.name;
        const selected_Option = this.product_variant?.options.find(
            (option: any) => option?.option?.type == "4"
        );
        this.selected_color =
            this.lang == "en"
                ? selected_Option?.values[0]?.name_en ||
                  selected_Option?.values[0]?.name
                : selected_Option?.values[0]?.name_ar ||
                  selected_Option?.values[0]?.name;
    }

    setMainData() {
        this.mainImgPath = this.product_variant?.image;
        this.detailData.images = [];
        this.detailData.stock = this.product_variant?.stock;
        this.detailData.images = this.product_variant?.images.length
            ? this.product_variant?.images
            : [{ url: this.mainImgPath }];
        this.detailData.name = this.product_variant?.name;
        this.detailData.description = 
            this.sanitizer.bypassSecurityTrustHtml(this.product_variant?.description);
        this.detailData.long_description =
            this.product_variant?.long_description;
        this.detailData.details = this.product_variant?.details;
        this.detailData.video = this.product_variant?.video;
        this.detailData.sku = this.product_variant?.sku;
        this.detailData.quantity = this.product_variant?.quantity;
        this.valueQuantity = this.product_variant?.quantity || 1;
        this.detailData.discount_price = this.product_variant?.discount_price;
        this.detailData.price = this.product_variant?.price;
        this.detailData.preorder = this.product_variant?.preorder;
        this.detailData.preorder_price = this.product_variant?.preorder_price;
        this.totalPrice = this.product_variant?.price;

        this.detailData.meta_title = this.product_variant?.name;
        this.getYouTubeUrlThumbnail();
    }

    openDialogSizeChart() {
        window.scrollTo(0, 0);
        const dialogRef = this.dialog.open(SizeChartsDialogComponent, {
            height: "auto",
            width: "500px",
            panelClass: "size-charts-dialog",
            data: {
                en:
                    this.detailData?.downloadable?.downloadable_url ||
                    this.detailData?.downloadable?.downloadable_url_ar,
                ar:
                    this.detailData?.downloadable?.downloadable_url_ar ||
                    this.detailData?.downloadable?.downloadable_url,
            },
        });
    }

    getCountStock(data: any) {
        if (data.stock) {
            this.detailData.in_stock = true;
        } else {
            data.in_Stock = false;
            this.detailData.in_stock = false;
        }
    }

    backButton() {
        this._location.back();
    }

    public calculatePrice(detailData: any, value: any) {
        detailData.quantity = value;
        detailData.totalPrice = detailData?.price * value;
        this.totalPrice = detailData?.price * value;
    }

    public reviewPopup(detailData: any) {
        let reviews: any = null;
        for (let review of this.productReviews) {
            reviews = review.user_rating;
        }

        this.embryoService.reviewPopup(detailData, reviews);
    }

    addToFavouriteList(variant: any) {
        this.toggleFavLoading = true;
        if (!variant.is_favourite) {
            this.reactivityService.setDataToStore("currentFavProduct", variant);
            this.marketingService.cartEvents("add_to_wishlist", variant);
        } else {
            this.reactivityService.setDataToStore(
                "currentUnFavouriteProduct",
                variant
            );
        }
    }

    addToCompareList(variant: any) {
        this.toggleCompareLoading = true;
        !variant.is_compare
            ? this.reactivityService.setDataToStore(
                  "addProductToCompare",
                  variant
              )
            : this.reactivityService.setDataToStore(
                  "removeProductFromCompare",
                  variant
              );
    }

    resetAvilableValueSize() {
        this.available_value_size?.forEach(
            (elemnt) => (elemnt.available_in_variant = false)
        );
        this.size_id = "";
        this.size_error = false;
    }

    showTabContent(tab: any) {
        this.activeTab = tab;
    }

    setOptionValuesStates() {
        this.detailData?.product_variants_options?.forEach((o: any) => {
            o.values?.forEach((value: any) => {
                if (
                    this.selectedValues.findIndex((v) => v.id == value.id) !==
                    -1
                ) {
                    value.state = 1;
                } else if (
                    this.availableValues.findIndex((v) => v.id == value.id) !==
                    -1
                ) {
                    value.state = 2;
                } else {
                    value.state = 3;
                }
            });
        });
    }

    getAvailableValues() {
        let availableValues: any[] = [];
        if (this.detailData?.product_variants_options.length == 1) {
            this.detailData?.product_variants?.forEach((pv: any) => {
                if (pv.options.length) {
                    availableValues.push(pv.options[0].values[0]);
                }
            });
        } else {
            this.selectedValues?.forEach((v) => {
                this.detailData?.product_variants?.forEach((p: any) => {
                    let ind = p.options.findIndex((o: any) => {
                        if (o.values.length) {
                            o.values[0].id == v.id;
                        }
                    });

                    if (ind !== -1) {
                        let otherValues = p.options
                            .filter((o: any) => {
                                let valueAvailable = true;
                                this.selectedValues?.forEach(
                                    (selectedValue) => {
                                        if (
                                            selectedValue.option_id !=
                                                v.option_id &&
                                            selectedValue.option_id !=
                                                o.option.id
                                        ) {
                                            let ind =
                                                this.detailData?.product_variants?.findIndex(
                                                    (pv: any) => {
                                                        let firstIndex =
                                                            pv.options.findIndex(
                                                                (opt: any) =>
                                                                    opt
                                                                        .values[0]
                                                                        .id ==
                                                                    selectedValue.id
                                                            );
                                                        let secIndex =
                                                            pv.options.findIndex(
                                                                (opt: any) =>
                                                                    opt
                                                                        .values[0]
                                                                        .id ==
                                                                    o.values[0]
                                                                        .id
                                                            );

                                                        return (
                                                            firstIndex !== -1 &&
                                                            secIndex !== -1
                                                        );
                                                    }
                                                );

                                            ind !== -1
                                                ? (valueAvailable = true)
                                                : (valueAvailable = false);
                                        }
                                    }
                                );
                                return (
                                    p.stock &&
                                    o.values[0].id != v.id &&
                                    v.option_id != o.option.id &&
                                    valueAvailable
                                );
                            })
                            .map((o: any) => o.values[0]);
                        availableValues = availableValues.concat(otherValues);
                    }
                });
            });
        }

        availableValues = availableValues.filter(
            (elem, index, self) =>
                self.findIndex((t) => t?.id === elem?.id) === index
        );
        return availableValues;
    }

    selectVariantFromDrobdown(
        option: any,
        value: any,
        optionValues: any,
        id?: number
    ) {
        let itemValue = optionValues.filter(
            (item: any) => item.id == value.value
        )[0];
        this.option2Selected = itemValue?.id;
        this.selectVariant(option, itemValue, id);
    }

    selectVariant(option: any, value: any, id?: number) {
        value.option_id = option.id;
         
        let selectedValues = JSON.parse(JSON.stringify(this.selectedValues));

        let valueInd = selectedValues.findIndex((v: any) => {
            return v.option_id == value.option_id;
        });

        if (valueInd !== -1) {
            selectedValues[valueInd] = value;
        }
        console.log('id', this.variantId)
        this.variantId = id;
        console.log('variantId', this.variantId)
        let existingVariant = this.variantFromValues(selectedValues);
        if (!existingVariant) {
            // get first available variant
            let firstAvavilable = this.getFirstAvailableVariant(value);
            this.variantId = firstAvavilable.id;
            this.selectedValues = firstAvavilable.options.map((o: any) => {
                let value = o.values[0];
                value.option_id = o.option.id;
                return value;
            });
        }

        if (this.variantId) {
            const index = this.detailData?.product_variants?.findIndex(
                (v: any) => v.id === this.variantId
            );
            if (index !== -1) {
                this.product_variant = this.detailData?.product_variants[index];
            }
        } else {
            this.product_variant = this.detailData?.product_variants[0];
            this._location.go(
                `/${this.lang}/${this.detailData?.product_variants[0].slug}`
            );
        }
        this.detailData?.product_variants?.forEach((element: any) => {
            if (
                this.userLoginServies.isGuest() &&
                localStorage.getItem("compareItems")
            ) {
                const index = JSON.parse(
                    <string>localStorage.getItem("compareItems")
                ).findIndex((item: any) => item.id == element.id);
                element.is_compare = index !== -1;
            } else {
                if (
                    this.compareListProducts &&
                    this.compareListProducts.length
                ) {
                    const index = this.compareListProducts.findIndex(
                        (item) => item.id == element.id
                    );
                    element.is_compare = index !== -1;
                }
            }
        });

        const ind = this.selectedValues.findIndex(
            (v) => v.option_id == option.id
        );
        this.selectedValues.splice(ind, 1);
        value.option_id = option.id;
        this.selectedValues.push(value);

        this.detailData?.product_variants?.forEach((variant: any) => {
            const variantValuesIds = variant.value_ids.sort();
            const selectedValueIds = this.selectedValues
                .map((v) => v.id)
                .sort();

            if (variantValuesIds.toString() == selectedValueIds.toString()) {
                this.product_variant = variant;
            }
        });

        this.detailData.meta_title = this.product_variant.name;
        this._location.go(
            `/${this.lang}/${this.product_variant.slug}`
        );

        this.setProductData();
        this.availableValues = this.getAvailableValues();
        this.setOptionValuesStates();

        let resultViewItem = <any>{
            content_ids: this.product_variant.id,
            content_category: this.detailData?.category?.name,
            content_name: this.product_variant.name,
            content_type: "product",
            contents: [{ id: this.product_variant.id, quantity: 1 }],
            currency: this.environmentVariables?.CURRENCY_CODE_EN,
            value: this.product_variant.discount_price
                ? this.product_variant.discount_price
                : this.product_variant.price,
        };
        this.marketingService.fbTracking(
            "track",
            "ViewContent",
            resultViewItem
        );

        if(this.environmentVariables?.tiktokPixelId){
            this.marketingService.ttqTracking('track', 'ViewContent', { resultViewItem })
        }

        this.marketingService.snapTracking(
            "track",
            "VIEW_CONTENT",
            {
                 item_ids:  this.product_variant?.id,
                price:this.product_variant?.discount_price
                       ? this.product_variant?.discount_price
                       : this.product_variant?.price,
                 currency: this.environmentVariables?.CURRENCY_CODE_EN,
            }
        );


        if (this.environmentVariables?.GOOGLE_CONVERSION_ID) {
            this.marketingService.googleConversionTracking(
                "conversion",
                this.environmentVariables?.GOOGLE_CONVERSION_ID,
                this.environmentVariables
                    ?.GOOGLE_CONVERSION_LABEL_PRODUCT_DETAILS_PAGE,
                this.environmentVariables?.GOOGLE_CONVERSION_TRANSACTION_ID
            );
        }
        
        let selected_Option = this.product_variant?.options.find(
            (option: any) => option?.option?.type == "4"
        );
        this.selected_color =
            this.lang == "en"
                ? selected_Option?.values[0]?.name_en ||
                  selected_Option?.values[0]?.name
                : selected_Option?.values[0]?.name_ar ||
                  selected_Option?.values[0]?.name;

                  // add meta tag here when variant change 

                  document
                .getElementById("MetaDescription")
                ?.setAttribute(
                    "content",
                    this.lang == 'en' ? this.product_variant?.name_en : this.product_variant?.name_ar
                );
                document
                .getElementById("keywordsMeta")
                ?.setAttribute(
                    "content",
                    this.lang == "en"
                        ? this.product_variant.keywords
                        : this.product_variant.keywords_ar
                );
                  this.metaService.updateTag({
                    property: "og:image",
                    content: this.product_variant.image,
                
                });
                document
                    .getElementById("ProductModelNo")
                    ?.setAttribute("content", this.product_variant.sku);
                if (this.lang == "en") {
                
                    this.metaService.updateTag({
                        property: "og:description",
                        content: this.product_variant.name_en,
                    });
                    this.metaService.updateTag({
                        property: "og:title",
                        content: this.product_variant?.name_en,
                    });
                    this.metaService.updateTag({
                        property: "keywords",
                        content:  this.product_variant.keywords 
                    });
                
                }else {
                    this.metaService.updateTag({
                        property: "og:description",
                        content: this.product_variant.name_ar,
                    });
                    this.metaService.updateTag({
                        property: "og:title",
                        content: this.product_variant?.name_ar,
                    });
                    this.metaService.updateTag({
                        property: "keywords",
                        content: this.product_variant.keywords_ar,
                    });
                }
    }

    /**
     * get the variant with the selected values combination
     * @param values
     * @returns
     */
    variantFromValues(values: any) {
        let value_ids = values.map((v: any) => v.id);

        let ind = this.detailData?.product_variants?.findIndex((pv: any) => {
            return (
                value_ids.sort().toString() == pv.value_ids.sort().toString()
            );
        });

        if (ind !== -1) {
            return this.detailData?.product_variants[ind];
        }
    }

    /**
     * gets first available variant with the a specific value
     * @param value
     * @returns
     */
    getFirstAvailableVariant(value: any) {
        for (let i = 0; i < this.detailData?.product_variants?.length; i++) {
            if (
                this.detailData?.product_variants[i].value_ids.includes(
                    value.id
                )
            ) {
                return this.detailData?.product_variants[i];
            }
        }
    }

    setProductData() {
        this.mainImgPath = this.product_variant.image;
        this.detailData.images = [];
        this.detailData.images = this.product_variant.images.length
            ? this.product_variant.images
            : [{ url: this.mainImgPath }];
        this.detailData.name = this.lang ==='en' ?  this.product_variant.name_en :this.product_variant.name_ar;
        this.detailData.description = this.sanitizer.bypassSecurityTrustHtml(this.product_variant.description);
        this.detailData.long_description = this.product_variant.long_description
        this.detailData.details = this.product_variant.details;
        this.detailData.sku = this.product_variant.sku;
        this.detailData.quantity = this.product_variant.quantity;
        this.detailData.stock = this.product_variant.stock;
        this.valueQuantity = this.product_variant.quantity || 1;
        this.detailData.discount_price = this.product_variant.discount_price;
        this.detailData.price = this.product_variant.price;
        this.totalPrice = this.product_variant.price;
        this.detailData.video = this.product_variant.video;
        this.getYouTubeUrlThumbnail();
    }

    getYouTubeUrlThumbnail() {
        if (this.detailData?.video) {
            const url = this.product_variant.video.split(
                /(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/
            );
            const youTubeID =
                url[2] !== undefined
                    ? url[2].split(/[^0-9a-z_\-]/i)[0]
                    : url[0];
            const fullUrl = ` https://img.youtube.com/vi/${youTubeID}/mqdefault.jpg`;
            this.youtubeTrustedThumbnailUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
            return this.youtubeTrustedThumbnailUrl;
        } else {
            return;
        }
    }

    notifyProduct(product: any) {
        this.user = JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
        if (!this.user) {
            if (localStorage.getItem("lang") === "en") {
                this.snackBar.open(
                    "Please, Login first! so that you can Notify product",
                    "×",
                    {
                        panelClass: "error",
                        verticalPosition: "top",
                        duration: 3000,
                    }
                );
            }
            else {
                this.snackBar.open(
                    "الرجاء تسجيل الدخول أولا! بحيث يمكنك تفعيل التنبيه ",
                    "×",
                    {
                        panelClass: "error",
                        verticalPosition: "top",
                        duration: 3000,
                    }
                );
            }
            this.router.navigate(["/" + this.lang + "/session/signin"]);
        }
        else {
            this.embryoService
                .PostRequestById("products/notify", product.id, product.id)
                .subscribe((response: any) => {
                    if (response.code === 200) {
                        if (localStorage.getItem("lang") === "en") {
                            this.snackBar.open(
                                "You will be notified when the item is available",
                                "×",
                                {
                                    panelClass: "success",
                                    verticalPosition: "top",
                                    duration: 3000,
                                }
                            );
                        } else {
                            this.snackBar.open(
                                "سوف يتم تبيهك عندما يكون المنتج متوفر",
                                "×",
                                {
                                    panelClass: "success",
                                    verticalPosition: "top",
                                    duration: 3000,
                                    direction: "rtl",
                                }
                            );
                        }
                    }
                });
        }
    }

    setVariantsFavorite() {
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        const favorite_items = this.isAuthUser
            ? this.wishListProducts
            : JSON.parse(<string>localStorage.getItem("wishListItems")) || [];

        this.detailData?.product_variants?.forEach((pv: any) => {
            const ind = favorite_items.findIndex((fi: any) => fi.id == pv.id);
            if (ind !== -1) {
                pv.is_favourite = true;
            } else {
                pv.is_favourite = false;
            }

            if (
                pv &&
                this.product_variant &&
                pv.id == this.product_variant.id
            ) {
                this.product_variant.is_favourite = pv.is_favourite;
            }
            this.toggleFavLoading = false;
        });
    }

    setVariantsCompare() {
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        const compareItems = this.isAuthUser
            ? this.compareListProducts
            : JSON.parse(<string>localStorage.getItem("compareItems")) || [];

        this.detailData?.product_variants?.forEach((pv: any) => {
            const ind = compareItems.findIndex((fi: any) => fi.id === pv.id);
            if (ind !== -1) {
                pv.is_compare = true;
            } else {
                pv.is_compare = false;
            }

            if (
                pv &&
                this.product_variant &&
                pv.id == this.product_variant.id
            ) {
                this.product_variant.is_compare = pv.is_compare;
            }
            this.toggleCompareLoading = false;
        });
    }

    createBreadCrumbsRoutes(): void {
        this.breadCrumbsRoutes.splice(1, this.breadCrumbsRoutes.length);
        const category = {
            matIcon: null,
            id: this.detailData?.category?.id,
            name_en: this.detailData?.category?.name?.replaceAll("_", " "),
            name_ar: this.detailData?.category?.name_ar?.replaceAll("_", " "),
            slug: this.detailData?.category?.slug,
        };
        this.breadCrumbsRoutes.push(category);
        const group = {
            matIcon: null,
            id: this.detailData?.group?.id,
            name_en: this.detailData?.group?.name_en?.replaceAll("_", " "),
            name_ar: this.detailData?.group?.name_ar?.replaceAll("_", " "),
            slug: this.detailData?.group?.slug,
        };
        this.breadCrumbsRoutes.push(group);

        const subCategoryParam = {
            matIcon: null,
            id: this.detailData?.category?.sub_categories[0]?.id,
            parent_id: this.detailData?.category?.id,
            name_en:
                this.detailData?.category?.sub_categories[0]?.name?.replaceAll(
                    "_",
                    " "
                ),
            name_ar:
                this.detailData?.category?.sub_categories[0]?.name_ar?.replaceAll(
                    "_",
                    " "
                ),
            slug: this.detailData?.category?.sub_categories[0]?.slug,
            parent_slug: this.detailData?.category?.slug,
        };
        this.breadCrumbsRoutes.push(subCategoryParam);
        const productDetails = {
            matIcon: null,
            name_en: this.detailData?.name?.replaceAll("_", " "),
            name_ar: this.detailData?.name_ar?.replaceAll("_", " "),
            slug: this.detailData?.slug,
            parent_slug: this.detailData?.category?.sub_categories[0]?.slug,
        };
        this.breadCrumbsRoutes.push(productDetails);
    }

    addToCart() {
        let incrementToCart = document.getElementById("incrementToCart");
        let addToCart = document.getElementById("addToCart");
        if (incrementToCart) {
            incrementToCart?.click();
        }
        else {
            addToCart?.click();
        }
        this.embryoService.productCartStatusCode.subscribe((res) => {
            this.cartStatusCode = res;

            if (this.cartStatusCode && this.cartStatusCode.code === 200) {
                if (
                    !this.environmentVariables.enable_guest_checkout &&
                    this.userLoginServies.isGuest()
                ) {
                    this.router.navigate(["/" + this.lang + "/cart"]);
                }
                else {
                    this.router.navigate(["/" + this.lang + "/checkout"]);
                }
            }
        });
    }


    isRateLoading=false;
    rateProduct(rateValue:any){
        this.isRateLoading = true;
        if(this.product_variant?.rate_details?.order_id){
            let data={
                rate:rateValue,
                product_id: this.product_variant.id,
                order_id: this.product_variant?.rate_details?.order_id
            }
            this.embryoService.RateProduct(data).subscribe(response=>{
               this.isRateLoading = false;
                if(response.code == 200){
                    this.product_variant.rate_details = response?.data?.rate_details;
                    Swal.fire({
                        html: `<p style='color:white'>${
                            this.lang == 'en' ?    "Product rated successfuly" : 'تم تقييم المنتج بنجاح '
                        }</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#51A351",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
                else {
                    Swal.fire({
                        html: `<p style='color:white'>${response.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#c20e0e",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            })
        }
        else {
            this.isRateLoading = false;
            this.product_variant.rate_details.user_rate = 0
            this.cdref.detectChanges();
            Swal.fire({
                html: `<p style='color:white'>${
                    this.lang == 'en' ? 
                   "You must order the product first before you can submit a review." : 'يجب الطلب من المنتج اولا حتي تتمكن من التقييم '
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#c20e0e",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }
    }

    calculatePercentage(count: number, totalCount: number): number {
        return totalCount > 0 ? (count / totalCount) * 100 : 0;
    }
 
    selectBank(bank: any) {
        this.selectedBank = bank;
        this.selectedInstallmentPlans = this.selectedBank.plans;
        this.selectedPlan = this.selectedInstallmentPlans[0];
    }
 
    selectPlan(plan: any) {
        this.selectedPlan = plan;
    }

    navigateToPlanSection(selectedInstallmentPlanInfoSection: string, isNavigationEvent: boolean){
        const selectedInstallmentPlanInfoElement = (<HTMLElement>document.querySelector(selectedInstallmentPlanInfoSection))
        selectedInstallmentPlanInfoElement.classList.toggle('d-none');
        if (isNavigationEvent) {
            window.scroll({
                top: selectedInstallmentPlanInfoElement.scrollHeight
            });
        }
    }
}
